import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid';
import _ from 'lodash';
import { Link, navigate } from 'gatsby';
import InternalLink from '../Link/Link'
import { Input } from '../FormFields';
import Search from '../../assets/icons/search.svg';
import Chevron from '../../assets/icons/chevron_right.svg';
import { withTranslation } from 'react-i18next';
import MenuContext from '../../util/MenuContext'

const SearchWrapper = ({ t, i18n, setSearchOverlay, autoFocus, preNavigate }) => {
  const [searchValue, setSearchValue] = useState('');
  const [validationMessage, setValidationMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const { popular } = React.useContext(MenuContext);

  const [searchResults, setSearchResults] = useState(popular)
  const langcode = i18n.language

  useEffect(() => {
    if (submitted) {
      validate(searchValue);

      if (searchValue.length) {
        preNavigate();
        navigate(`${t('search.url')}?term=${searchValue}`);
      } else {
        setSubmitted(false)
      }
    }
  }, [searchValue, submitted])

  const onBlur = e => {
    setValidationMessage('');
  };

  const onChange = async e => {
    const searchQuery = e.target.value
    setSearchValue(searchQuery);
    validate(searchQuery);

    if (!searchQuery.length) {
      setSearchResults(popular)
      return
    }
    const lunr = await window.__LUNR__.__loaded

    // Get exact matches
    let refs = _.slice(lunr[langcode.toLowerCase()].index.search(`${searchQuery}`), 0, 5)

    // Try to get matches with wildcard
    if (_.isEmpty(refs)) {
      refs = _.slice(lunr[langcode.toLowerCase()].index.search(`${searchQuery}*`), 0, 5)
    }

    if (_.isEmpty(refs)) {
      setValidationMessage(t('search_bar.no_results'));
      return
    }
    const pages = refs.map(({ ref }) => lunr[langcode.toLowerCase()].store[ref]).map(page => {
      return {
        label: page.title,
        url: {
          path: `${page.url}?hl=${searchQuery}`
        }
      }
    })
    setSearchResults(pages)
  };

  const onSubmit = e => {
    e.preventDefault();

    setSubmitted(true);
  };

  const validate = input => {
    if (input.length === 0) {
      setValidationMessage(t('search_bar.validation_message'));
    } else {
      setValidationMessage('');
    }
  };

  return (
    <div className="desktop-search" id="zoeken">
      <form action="#" className="search-form" onSubmit={onSubmit}>
        <Search className="search-icon" />
        <Input
          type="search"
          label={t("search_bar.placeholder")}
          autoFocus={autoFocus}
          placeholder={t("search_bar.placeholder")}
          onBlur={e => onBlur(e)}
          onChange={e => onChange(e)}
          value={searchValue}
          validationMessage={validationMessage}
        />
        <button type="submit" className="search-button">Zoeken</button>
        <div className="dropdown-wrapper">
          <ul className="dropdown">
            {searchResults.map(item => (
              <li className="dropdown-item" key={uuid()}>
                <Link to={item.url.path} onClick={() => setSearchOverlay(false)}>
                  <Chevron />
                  <span>{item.label}</span>
                </Link>
              </li>
            ))}
            {!_.isEmpty(searchValue) && !_.isEmpty(searchResults) && (<li>
              <InternalLink onClick={() => setSearchOverlay(false)} type="arrow" href={`${t('search.url')}?term=${searchValue}`}>{t('search_bar.more_results')}</InternalLink>
            </li>)}
          </ul>
        </div>
      </form>
    </div>
  );
};

SearchWrapper.defaultProps = {
  autoFocus: true,
  preNavigate: () => {},
};

SearchWrapper.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  setSearchOverlay: PropTypes.func,
  preNavigate: PropTypes.func,
};

export default withTranslation()(SearchWrapper);
